import { useState } from "react";
import axios from "axios";
import { server } from "../server";
import { toast } from "react-toastify";
import { Navigate, useNavigate } from "react-router-dom";
import { getDecodedToken } from "../auth";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [emailError, setEmailError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const [session, setSession] = useState("2026-27");
  const navigate = useNavigate();

  const user = getDecodedToken();
  if (user) return <Navigate to="/home" replace />;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    setEmailError(!email.trim());
    setPasswordError(!password.trim());

    if (!email.trim() || !password.trim()) {
      setLoading(false);
      return;
    }

    try {
      const response = await axios.post(`${server}/login_admin_mongodb`, {
        email,
        password,
        session,
      });

      const bodyJson = response.data["body-json"];
      const statusCode = bodyJson?.statusCode;
      const parsedBody = JSON.parse(bodyJson?.body || "{}");
      const token = parsedBody?.token;

      if (statusCode === 200 && token) {
        localStorage.setItem("token", token);
        navigate("/home", { replace: true });
      } else {
        const errorMsg = parsedBody?.message || "Login failed";
        setError(errorMsg);
        toast.error(errorMsg, { position: "top-right" });
      }
    } catch (err) {
      const errorMsg = err.response?.data?.message || "Something went wrong";
      setError(errorMsg);
      toast.error(errorMsg, { position: "top-right" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <main>
        <section className="container d-flex flex-column vh-100">
          <div className="row align-items-center justify-content-center g-0 h-lg-100 py-8">
            <div className="col-lg-5 col-md-8 py-8 py-xl-0">
              <div className="card shadow rounded-5">
                <div className="card-body p-6 d-flex flex-column rounded-5 gap-3">
                  <div className="d-flex align-content-center align-items-center">
                    <img
                      src="/assets/images/icon.png"
                      width="60"
                      height="60"
                      className="me-3"
                      alt="logo-icon"
                    />
                    <div className="ms-1">
                      <h1 className="m-0 fw-bold h3 lh-sm">Sign in</h1>
                      <span>
                        Don’t have an account?
                        <a href="#" className="ms-1">
                          Contact Us
                        </a>
                      </span>
                    </div>
                  </div>
                  <form onSubmit={handleSubmit} className="needs-validation">
                    <div className="mb-2">
                      <label className="form-label">
                        Username / Email ID
                        <span className="fw-bold text-danger ms-1">*</span>
                      </label>
                      <input
                        type="text"
                        className={`form-control ${
                          emailError ? "border-danger" : ""
                        }`}
                        placeholder="Username / Email ID"
                        value={email}
                        onChange={(e) => {
                          setEmail(e.target.value);
                          setEmailError(false);
                        }}
                      />
                    </div>
                    <div className="mb-2">
                      <label className="form-label">
                        Password
                        <span className="fw-bold text-danger ms-1">*</span>
                      </label>
                      <input
                        type="password"
                        className={`form-control ${
                          passwordError ? "border-danger" : ""
                        }`}
                        value={password}
                        onChange={(e) => {
                          setPassword(e.target.value);
                          setPasswordError(false);
                        }}
                        placeholder="**********"
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">
                        Academic Session
                        <span className="fw-bold text-danger ms-1">*</span>
                      </label>
                      <div className="row g-2">
                        <div className="col-4">
                          <div
                            onClick={() => setSession("2025-26")}
                            className={`border rounded-3 p-2 text-center d-flex align-items-center justify-content-center cursor-pointer ${
                              session === "2025-26"
                                ? "bg-info-soft border-info"
                                : "bg-white"
                            }`}
                          >
                            <p className="fs-4 m-0 eczar-font fw-medium text-black">
                              2025 - 26
                            </p>
                          </div>
                        </div>
                        <div className="col-4">
                          <div
                            onClick={() => setSession("2026-27")}
                            className={`border rounded-3 p-2 text-center d-flex align-items-center justify-content-center cursor-pointer ${
                              session === "2026-27"
                                ? "bg-info-soft border-info"
                                : "bg-white"
                            }`}
                          >
                            <p className="fs-4 m-0 eczar-font fw-medium text-black">
                              2026 - 27
                            </p>
                          </div>
                        </div>
                        <div className="col-4">
                          <div
                            onClick={() => setSession("2027-28")}
                            className={`border rounded-3 p-2 text-center d-flex align-items-center justify-content-center cursor-pointer ${
                              session === "2027-28"
                                ? "bg-info-soft border-info"
                                : "bg-white"
                            }`}
                          >
                            <p className="fs-4 m-0 eczar-font fw-medium text-black">
                              2027 - 28
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="d-lg-flex justify-content-between align-items-center mb-3 mt-4">
                      <div className="form-check">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="rememberme"
                          required=""
                        />
                        <label
                          className="form-check-label"
                          htmlFor="rememberme"
                        >
                          Remember me
                        </label>
                        <div className="invalid-feedback">
                          You must agree before submitting.
                        </div>
                      </div>
                      <div>
                        <a href="#">
                          Forgot Password{" "}
                          <i className="bi bi-info-circle-fill ms-1"></i>
                        </a>
                      </div>
                    </div>
                    <div>
                      <div className="d-grid">
                        <button
                          type="submit"
                          className="btn btn-primary"
                          disabled={loading}
                        >
                          {loading ? (
                            <div
                              class="spinner-border spinner-border-sm"
                              role="status"
                            ></div>
                          ) : (
                            "Sign in"
                          )}
                        </button>
                      </div>
                      <div className="text-center mt-3">
                        <span>
                          Acharyakulam Ranchi
                          <a
                            href="https://www.acharyakulamranchi.com/"
                            target="_blank"
                            className="ms-2"
                          >
                            <i className="bi bi-box-arrow-up-right"></i>
                          </a>
                        </span>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}

export default Login;
